export default __webpack_public_path__ + "static/media/happy-birthday-crowd.4f78f9d5.mp3";